"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnActionItems = exports.useCanUserSetColumnDescription = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const react_query_1 = require("@tanstack/react-query");
const react_1 = tslib_1.__importDefault(require("react"));
const ColumnActions_1 = require("./types/ColumnActions");
function useCanUserSetColumnDescription(tableVizportalId) {
    const { canUserSetColumnDescription } = (0, catalog_core_1.useApiRequests)();
    const { data } = (0, react_query_1.useQuery)({
        queryKey: ['user-edit-column', tableVizportalId],
        queryFn: () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield canUserSetColumnDescription({ tableVizportalId: tableVizportalId !== null && tableVizportalId !== void 0 ? tableVizportalId : '' }); }),
        enabled: !!tableVizportalId,
    });
    return data !== null && data !== void 0 ? data : false;
}
exports.useCanUserSetColumnDescription = useCanUserSetColumnDescription;
function useColumnActionItems(params) {
    return react_1.default.useMemo(() => {
        const disabled = !params.canUpdateTable || !(params.columnLuid !== undefined);
        const labelActionItemInfo = {
            value: 'labelActionSubmenu',
            displayValue: catalog_messages_1.Messages.LabelActionSubmenu(),
            menuItemInfos: [
                {
                    value: ColumnActions_1.ColumnActions.QualityWarning,
                    displayValue: catalog_messages_1.Messages.DataQualityWarningAction(),
                    disabled,
                },
                {
                    value: ColumnActions_1.ColumnActions.SensitiveLabels,
                    displayValue: catalog_messages_1.Messages.SensitiveLabelAction(),
                    disabled,
                },
                {
                    value: ColumnActions_1.ColumnActions.CustomLabels,
                    displayValue: catalog_messages_1.Messages.MoreLabelsAction(),
                    disabled,
                },
            ],
            disabled,
        };
        return [
            {
                value: ColumnActions_1.ColumnActions.Tag,
                displayValue: catalog_messages_1.Messages.TagAction(),
                disabled: !params.canUpdateTable,
            },
            {
                value: ColumnActions_1.ColumnActions.Description,
                displayValue: catalog_messages_1.Messages.EditDescriptionAction(),
                disabled: !params.canUpdateTable,
            },
            { isDivider: true },
            labelActionItemInfo,
        ];
    }, [params.canUpdateTable, params.columnLuid]);
}
exports.useColumnActionItems = useColumnActionItems;
//# sourceMappingURL=ColumnDetailsHooks.js.map